import { type Artikel } from '../_tools/Werbung';

const sArtikel: Artikel[] = [
    { i: 7, t: 'Vertrag ohne Einrichtungsgebühr' },
    { i: 8, t: 'Vertrag Standard' },
    { i: 9, t: 'UWE-X (alt) 12M', mlz: '2 Jahre' },
    { i: 10, t: 'Jahresvertrag Prepayed' },
    { i: 11, t: 'Vertrag Sondertarif' },
    { i: 12, t: 'Vertrag Standard mit Tracking' },
    { i: 13, t: 'UWE-X (alt) 12M + Tracking', mlz: '2 Jahre' },
    { i: 14, t: 'Jahresvertrag mit Tracking' },
    { i: 15, t: 'Vertrag Standard ohne Tracking' },
    { i: 16, t: 'Jahresvertrag Standard mit Tracking' },
    { i: 17, t: 'Jahresvertrag Prepayed ohne Tracking' },
    { i: 18, t: '2-Jahresvertrag mit Tracking (Prepayed)' },
    { i: 19, t: '1-Jahresvertrag Prepayed mit Tracking' },
    { i: 20, t: '2-Jahresvertrag Prepayed ohne Tracking' },
    { i: 21, t: '1-Jahresvertrag Prepayed ohne Tracking' },
    { i: 22, t: '2-Jahresvertrag Prepayed' },
    { i: 27, t: '2-Jahresvertrag Prepayed DD1' },
    { i: 28, t: '2-Jahresvertrag Prepayed DD2' },
    { i: 29, t: '2-Jahresvertrag mit Tracking' },
    { i: 30, t: '2 Jahre / jährlich / 1501,20' },
    { i: 31, t: '1 Jahr / jährlich / 1668,00' },
    { i: 32, t: '6 Monate / monatlich / 139,00' },
    { i: 33, t: '1 Jahr / jährlich / 1501,20' },
    { i: 34, t: '2-Jahresvertrag Prepayed DD1-2010' },
    { i: 35, t: '2-Jahresvertrag Prepayed DD2-2010' },
    { i: 36, t: '2-Jahresvertrag mit Tracking R' },
    { i: 41, t: '2-Jahresvertrag Prepayed mit Tracking x 4 Standort' },
    { i: 50, t: 'UWE-X (alt) 6M M (50)', mlz: '2 Jahre' },
    { i: 51, t: 'UWE-X (alt) 6M M (51)', mlz: '2 Jahre' },
    { i: 52, t: 'UWE-X (alt) 1J J', mlz: '2 Jahre' },
    { i: 53, t: 'UWE-X (alt) 2J J', mlz: '2 Jahre' },
    { i: 54, t: 'UWE-X (alt) 2J M', mlz: '2 Jahre' },
    { i: 55, t: 'UWE-X (99) 2J J', mlz: '2 Jahre' },
    { i: 56, t: 'UWE-X 2J J', p: 99, mlz: '2 Jahre' },
    { i: 57, t: 'UWE-X 2J M', p: 99, mlz: '2 Jahre' },
    { i: 58, t: 'UWE-X 2J J (ohne Benutzer)', p: 99, mlz: '2 Jahre' },
    { i: 59, t: 'UWE-X 2J M (ohne Benutzer)', p: 99, mlz: '2 Jahre' },
    { i: 60, t: 'UWE-X 6M M (ohne Benutzer) + Einrichtung 299€', mlz: '2 Jahre' },
    { i: 70, t: '(HP (alt) (70))' },
    { i: 71, t: '(HP (alt) (71))' },
    { i: 72, t: '(HP (alt) (72))' },
    { i: 73, t: '(HP (alt) (73))' },
    { i: 74, t: '(HP (alt) (74))' },
    { i: 75, t: 'HP CI', p: 1188, mlz: '1 Jahr', z: 'Jahr' },
    { i: 76, t: 'HP Mobile' },
    { i: 80, t: 'HP Gruppe', p: 948, mlz: '1 Jahr', z: 'Jahr' },
    { i: 85, t: 'Mail-Hosting' },
    { i: 90, t: 'individuelle Datenlieferung (alt)' },
    { i: 91, t: 'JSON-API', p: 468, mlz: '1 Jahr', z: 'Jahr' },
    { i: 92, t: 'Nutzung Bilderserver' },
    { i: 93, t: 'individuelle Datenlieferung (CSV)', p: 120, mlz: '1 Jahr', z: 'Jahr' },
    { i: 94, t: 'individuelle Datenlieferung (ZIP)', p: 120, mlz: '1 Jahr', z: 'Jahr' },
    { i: 104, t: 'Stapelbild' },
    { i: 105, t: 'HPT (KP2)' },
    { i: 113, t: 'Benutzerberechung' },
    { i: 114, t: 'Rechnung per Post' },
    { i: 117, t: 'Barcode' },
    { i: 150, t: 'Tracking', p: 40, mlz: '1 Monat', z: 'Monat' },
    { i: 151, t: 'BDC', p: 40, mlz: '1 Monat', z: 'Monat' },
    { i: 152, t: 'Akte', p: 40, mlz: '1 Monat', z: 'Monat' },
    { i: 153, t: 'CarScanner', p: 40, mlz: '1 Monat', z: 'Monat' },
    { i: 154, t: 'Kundenmanagement' },
    { i: 155, t: 'Inzahlungnahme' },
    { i: 157, t: 'Leadmanagement', p: 49, mlz: '6 Monate', z: 'Monat' },
    { i: 159, t: 'HD-Bilder', p: 10, mlz: '1 Monat', z: 'Monat' },
    { i: 200, t: 'Artikel individuell' },
];

export default sArtikel;
